import { Accordion, AccordionBody, AccordionHeader } from "design-react-kit";
import { useState } from "react";
import DualBarChart from "./DualBarChart";
import BarChartComponent from "./BarChartComponent";

const ChartAccordionItem = ({ data, year }) => {
  const [dataCollapseOpen, setDataCollapseOpen] = useState(false);

  const collapseHandler = (e) => {
    setDataCollapseOpen((prevState) => !prevState);
  };

  const showMonth = (monthNumber) => {
    switch (monthNumber) {
      case 1:
        return "Gennaio";
      case 2:
        return "Febbraio";
      case 3:
        return "Marzo";
      case 4:
        return "Aprile";
      case 5:
        return "Maggio";
      case 6:
        return "Giugno";
      case 7:
        return "Luglio";
      case 8:
        return "Agosto";
      case 9:
        return "Settembre";
      case 10:
        return "Ottobre";
      case 11:
        return "Novembre";
      case 12:
        return "Dicembre";

      default:
        break;
    }
  };

  return (
    <div className="chart-accordion">
      <Accordion iconLeft className="border-bottom-0 w-100 p-0 m-0">
        <AccordionHeader
          className="chartAccordion w-100 pt-0"
          active={dataCollapseOpen}
          onToggle={(e) => collapseHandler(e)}
        >
          <div className="details-wrapper">
            <h6 className="mt-4 text-nowrap col-2">
              Notifiche {showMonth(data.month)} {year} ({data.total.sent})
            </h6>
            <div className="details-bars">
              <div className="col-5">
                <DualBarChart
                  width={620}
                  height={70}
                  data={[data.total]}
                  hideName={true}
                  showTotals={false}
                  left={10}
                />
              </div>
              <div className="col-5 mr-5">
                <BarChartComponent
                  width={600}
                  height={70}
                  data={[data.total]}
                  hideName={true}
                  showTotals={false}
                  left={10}
                />
              </div>
            </div>
          </div>
        </AccordionHeader>
        <AccordionBody className="chartAccordionBody" active={dataCollapseOpen}>
          {data.services
            .filter((service) => service.sent > 0)
            .map(
              (item) =>
                item.sent !== undefined && (
                  <div key={item.code} className="details-wrapper">
                    <h6 className="mt-4 text-nowrap col-1">
                      {item.code} ({item.sent})
                    </h6>
                    <div className="details-bars">
                      <div className="col-sm-12 col-xl-5">
                        <DualBarChart
                          width={620}
                          height={70}
                          data={[item]}
                          hideName={true}
                          showTotals={false}
                        />
                      </div>
                      <div className="col-sm-12 col-xl-5">
                        <BarChartComponent
                          width={600}
                          height={70}
                          data={[item]}
                          hideName={true}
                          showTotals={false}
                        />
                      </div>
                    </div>
                  </div>
                ),
            )}
        </AccordionBody>
      </Accordion>
    </div>
  );
};

export default ChartAccordionItem;
